import React, { memo } from 'react'
import InfoIcon from 'transfix-icons/build/InfoIcon'
import { useBreakpointContext } from 'utils/context/BreakpointContext'
import { IDriver } from 'apps/fleet-planner/types'
import { getOverridePositionProp } from 'apps/fleet-planner/utils/getMobileTooltipPosition'
import { Tooltip } from 'transfix-ui'

interface IDeactivatedDriverTooltipProps {
  driver?: IDriver
  isDriversPage?: boolean
  isDriversModal?: boolean
  className?: string
  // This is here to help with positioning the icon to be inline with the text
  iconClassName?: string
}

const driversPageText = (
  <p className='body-semibold'>
    Deactivating a driver will remove them from your Fleet <br />
    view and prevent dispatchers from assigning them to loads. <br /> You can reactivate a driver at
    any time.
  </p>
)

export const DeactivatedDriverToolTip = memo<IDeactivatedDriverTooltipProps>(
  ({ className, driver, iconClassName, isDriversModal = false, isDriversPage = false }) => {
    const { isMobile = false } = useBreakpointContext()
    const overridePosition = getOverridePositionProp(isMobile)
    return (
      <Tooltip
        position={isDriversPage ? 'right' : 'top'}
        type='dark'
        overridePosition={overridePosition}
        trigger={
          <span className={`${className || ''}`}>
            <InfoIcon size='medium' className={`deactivated-driver-icon ${iconClassName || ''}`} />
          </span>
        }>
        {isDriversPage || isDriversModal ? (
          driversPageText
        ) : (
          <>
            {driver && <p className='body-semibold'>This driver ({driver.name}) is deactivated.</p>}
            <p className='body-semibold'>They can no longer be assigned to loads.</p>
          </>
        )}
      </Tooltip>
    )
  }
)
